import { useState } from "react";
import { FileText, HelpCircle, MessageSquare, Star } from "lucide-react";

// Import sub-pages
import ArticlesCMS from "@/components/admin/ArticlesCMS";
import FaqCMS from "@/components/admin/FaqCMS";
import TemoignagesCMS from "@/components/admin/TemoignagesCMS";
import MessagesCMS from "@/components/admin/MessagesCMS";

const tabs = [
  { id: "articles", label: "Articles Blog", icon: FileText },
  { id: "faq", label: "FAQ", icon: HelpCircle },
  { id: "temoignages", label: "Témoignages", icon: Star },
  { id: "messages", label: "Messages Auto", icon: MessageSquare },
];

export default function CMSPage() {
  const [activeTab, setActiveTab] = useState("articles");

  return (
    <div data-testid="cms-page">
      <div className="mb-8">
        <h2 className="text-2xl font-display text-[#004333]">Gestion du contenu</h2>
        <p className="text-gray-500">Blog, FAQ, témoignages et messages automatiques</p>
      </div>

      <div className="flex gap-2 mb-8 border-b border-gray-200">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-4 py-3 font-medium transition-colors border-b-2 -mb-px ${
                activeTab === tab.id
                  ? "text-[#004333] border-[#C9922A]"
                  : "text-gray-500 border-transparent hover:text-[#004333]"
              }`}
            >
              <Icon className="w-4 h-4" />
              {tab.label}
            </button>
          );
        })}
      </div>

      {activeTab === "articles" && <ArticlesCMS />}
      {activeTab === "faq" && <FaqCMS />}
      {activeTab === "temoignages" && <TemoignagesCMS />}
      {activeTab === "messages" && <MessagesCMS />}
    </div>
  );
}
